export enum BreadcrumbParams {
  ActiveMenuName = 'activeMenuName',
  MaintenanceJobName = 'maintenanceJobName',
  MaintenanceJobNameFromVersion = 'maintenanceJobNameFromVersion',
  CorrectiveActionName = 'correctiveActionName',
  ServiceReportName = 'serviceReportName',
  UserDetails = 'userDetails',
  UserCompetenceName = 'userCompetenceName',
  CompetenceUserName = 'competenceUserName',
  PaxDetails = 'paxDetails',
  CertificateName = 'certificateName',
  DocumentName = 'documentName',
  DocumentStructureName = 'documentStructureName',
  RiskAssessmentName = 'riskAssessmentName',
  RiskAssessmentVersionName = 'riskAssessmentVersionName',
  NonConformanceName = 'nonConformanceName',
  TaskName = 'taskName',
  DrillName = 'drillName',
  RunTimeName = 'runTimeName',
  ProductName = 'productName',
  MedicineName = 'medicineName',
  OrderName = 'orderName',
  OrderStageLabel = 'orderStageLabel',
  DepartmentName = 'departmentName',
  DepartmentGroupName = 'departmentGroupName',
  AlertName = 'alertName',
  QuantityTypeName = 'quantityTypeName',
  ShiftName = 'shiftName',
  ActivityName = 'activityName',
  CustomFormName = 'customFormName',
  FormLibraryName = 'formLibraryName',
  MedicineCategoryName = 'medicineCategoryName',
  ProductCategoryName = 'productCategoryName',
  ProductTypeName = 'productTypeName',
  CertificateTypeName = 'certificateTypeName',
  OrderTypeName = 'orderTypeName',
  AccountName = 'accountName',
  AccountGroupName = 'accountGroupName',
  DeliveryConditionName = 'deliveryConditionName',
  DeliveryAddressName = 'deliveryAddressName',
  SupplierName = 'supplierName',
  PurchaserName = 'purchaserName',
  SfiCodeName = 'sfiCodeName',
  NonConformanceTypeName = 'nonConformanceTypeName',
  SeverityTypeName = 'severityTypeName',
  CauseName = 'causeName',
  SeaStateName = 'seaStateName',
  WeatherInformationName = 'weatherInformationName',
  LocationOnDepartmentName = 'locationOnDepartmentName',
  CompetenceName = 'competenceName',
  CompetenceGroupName = 'competenceGroupName',
  CompetenceRequirementName = 'competenceRequirementName',
  JobPositionName = 'jobPositionName',
  JobPositionGroupName = 'jobPositionGroupName',
  CompetenceRoleName = 'competenceRoleName',
  PrivilegeTemplateName = 'privilegeTemplateName',
  TenantName = 'tenantName',
  ProductOwnerName = 'productOwnerName',
  TripName = 'tripName',
  JobTypeName = 'jobTypeName',
  JobAreaName = 'jobAreaName',
  StandardJobTemplateName = 'standardJobTemplateName',
  ComponentName = 'componentName',
  ComponentGroupName = 'componentGroupName',
  SubtaskName = 'subtaskName',
  CustomPropertyName = 'customPropertyName',
  WorkScheduleTemplateName = 'workScheduleTemplateName',
  WorkOverviewName = 'workOverviewName',
  OvertimeTypeName = 'overtimeTypeName',
  WorkPlanTemplateName = 'workPlanTemplateName',
  SignOffName = 'signOffName',
  ProjectName = 'projectName',
  MaintenanceSettingsName = 'maintenanceSettingsName',
}
